// Comprobante térmico de CORTESÍA — presentacional puro (oculto en pantalla, visible al imprimir).
// Sprint 43.0 — Espeja el builder ESC/POS (escposHelper.buildCortesiaTicket). Documental: muestra el
// valor del servicio otorgado sin cobro + dos firmas (encargado de turno y gerencia). SOLO presentación.
const money = (v) => `$${Number(v || 0).toFixed(2)}`;

export const CortesiaThermalReceipt = ({ cortesia, paperWidth }) => {
  if (!cortesia) return null;
  return (
    <div className={`thermal-receipt tr-cortesia tr-w${paperWidth}`} data-testid="cortesia-thermal">
      <div className="tr-center tr-brand">{cortesia.brand || "PARKNOVA"}</div>
      <div className="tr-center tr-bold tr-lg">COMPROBANTE DE CORTESÍA</div>
      <div className="tr-sep">--------------------------------</div>

      {cortesia.sucursal ? <div className="tr-sm">Sucursal: {cortesia.sucursal}</div> : null}
      {cortesia.folio ? <div className="tr-sm">Folio: {cortesia.folio}</div> : null}
      <div className="tr-sm">Fecha: {cortesia.fecha}</div>
      <div className="tr-sm" data-testid="cortesia-motivo">Motivo: {cortesia.motivo || "-"}</div>
      {cortesia.operador ? <div className="tr-sm">Aplicó: {cortesia.operador}</div> : null}
      {cortesia.reimpresion ? <div className="tr-center tr-bold tr-sm">** REIMPRESIÓN **</div> : null}
      <div className="tr-sep">--------------------------------</div>

      <div className="tr-center tr-bold" style={{ marginTop: "4px" }}>IMPORTE DE CORTESÍA</div>
      <div className="tr-center tr-bold tr-lg" data-testid="cortesia-importe">{money(cortesia.importe)}</div>
      <div className="tr-center tr-sm">Valor del servicio otorgado sin cobro</div>
      <div className="tr-sep">--------------------------------</div>

      <div className="tr-sign" style={{ marginTop: "10px" }}><span className="tr-fill" /></div>
      <div className="tr-center tr-sm tr-bold">Firma del encargado de turno</div>
      <div className="tr-sign" style={{ marginTop: "12px" }}><span className="tr-fill" /></div>
      <div className="tr-center tr-sm tr-bold">Firma de gerencia (si aplica)</div>
    </div>
  );
};

export default CortesiaThermalReceipt;
